import { useState } from 'react';
import { reportOptimizely } from 'externals/_tracking/optimizely';
import {
  CLICK,
  SEEN_OFFER,
} from 'externals/_tracking/types/eventTypes.constants';
import classnames from 'classnames';
import { SUBSCRIPTION_VERTICAL } from 'types/mrph.vertical.constants';
import { useSubscriptionLandingUrl } from 'hook/subscriptionLandingUrl.hook';

export const usePremiumUpsell = (creditInfo, history, eventHandler) => {
  const [isSeenTriggered, setIsSeenTriggered] = useState(false);
  const belowBandCreditScore = creditInfo && creditInfo.creditScore < 700;
  const displayClasses = classnames({
    belowBand: belowBandCreditScore,
    aboveBand: !belowBandCreditScore,
  });
  const { subscriptionLandingUrl } = useSubscriptionLandingUrl();

  const handleCTAClick = e => {
    e.preventDefault();
    eventHandler(CLICK, {
      'Click Type': `Premium Banner Upgrade`,
      'Page Position': 'Premium',
      Vertical: SUBSCRIPTION_VERTICAL,
    });
    reportOptimizely('premiumUpsellCTAClick');
    history.push(subscriptionLandingUrl);
  };

  const onVisibilityChange = isVisible => {
    if (isVisible === true && !isSeenTriggered) {
      eventHandler(SEEN_OFFER, {
        'Product Offer': 'Premium',
        'Page Position': 'Premium',
        Vertical: 'Preimum',
      });
      setIsSeenTriggered(true);
    }
  };

  return {
    handleCTAClick,
    onVisibilityChange,
    displayClasses,
    belowBandCreditScore,
  };
};
